import React from "react";
import { Grid } from "components/src/components/Grid/Grid";
import MappedSelection from "./MappedSelection";
import { spanMap } from "../js/spanMap";
import { MarketCompetitor } from "./MarketCompetitor";
import { VersusDivider } from "./VersusDivider";
/**
 * MarketRow - Apart of the Market component
 * Renders a single Market Row which consists of a Competitor and Selections in a Grid.
 * @param param0
 * @returns
 */
export function MarketRow({
  useSingleSelection,
  dataFilterGroup,
  marketId,
  marketTemplateType,
  rest,
  hasCompetitor,
  hasMultipleCompetitors,
  hasName,
  hideCompetitor,
  wrapperRef,
  selections,
  randIdString,
  marketButtonData,
  marketCompetitorProps,
  canShowVersusDivider,
  showVersusDivider,
  hasScore,
  sport,
  isOddsBoost,
  type,
}) {

  const _colSpan = !isOddsBoost ? spanMap[selections?.length] : spanMap[selections?.length] - 2;
  return (
    <div
      className={`cui__market_row_wrapper cui-relative ${!showVersusDivider ? "cui-mt-2xs" : ""}`}
    >
      <Grid
        className="cui__market_row"
        data-filter-group={!useSingleSelection ? dataFilterGroup : null}
        id={marketId || randIdString.current}
        {...rest}
        flush
      >
        {(hasCompetitor || hasMultipleCompetitors || hasName) &&
        !hideCompetitor ? (
          <Grid.Cell
            colSpan={_colSpan}
            className="cui-flex cui-items-center"
            ref={wrapperRef}
          >
            <MarketCompetitor {...marketCompetitorProps} />
          </Grid.Cell>
        ) : null}
        {selections?.map((selection, i) => (
          <MappedSelection
            key={`${selection?.id}-${i}`}
            index={i}
            selection={selection}
            marketButtonData={marketButtonData}
            marketTemplateType={marketTemplateType}
            hasMultipleCompetitors={hasMultipleCompetitors}
          />
        ))}
      </Grid>
      {canShowVersusDivider && !hasMultipleCompetitors ? (
        <VersusDivider
          hasScore={hasScore}
          show={canShowVersusDivider}
          sport={sport}
          selectionsLength={selections?.length}
        />
      ) : null}
    </div>
  );
}
